// extracted by mini-css-extract-plugin
module.exports = {"section":"ImagesPanorama_section__360G-","image":"ImagesPanorama_image__X3mrW"};